import cx from "classnames";
import React from "react";
import DisplayOptionsProvider from "../DisplayOptionsProvider/DisplayOptionsProvider";
import JourneyProvider from "../JourneyProvider";
import JourneyTimeInformation from "../JourneyTimeInformation";
import JourneyTrack from "../JourneyTrack";
import LocalizationProvider from "../LocalizationProvider";
import * as s from "./JourneyLiveTracker.module.css";
const JourneyLiveTracker = ({
  journey,
  locale = "en-gb",
  className,
  onInitializationStart,
  onInitializationCompleted,
  onRefetchStart,
  onRefetchCompleted,
  onFetchError,
  disableFetch,
  displayOptions
}) => /* @__PURE__ */ React.createElement(LocalizationProvider, {
  locale
}, /* @__PURE__ */ React.createElement(DisplayOptionsProvider, {
  displayOptions: displayOptions || null
}, /* @__PURE__ */ React.createElement("div", {
  className: cx(s.journeyLiveTracker, className),
  "data-testid": "journey-live-tracker"
}, /* @__PURE__ */ React.createElement(JourneyProvider, {
  journey,
  onInitializationStart,
  onInitializationCompleted,
  onRefetchStart,
  onRefetchCompleted,
  onFetchError,
  disableFetch
}, /* @__PURE__ */ React.createElement(JourneyTimeInformation, null), /* @__PURE__ */ React.createElement(JourneyTrack, null)))));
var JourneyLiveTracker_default = JourneyLiveTracker;
export {
  JourneyLiveTracker,
  JourneyLiveTracker_default as default
};
